import React from "react";
import Markdown from "react-native-markdown-display";
import { UnistylesRuntime } from "react-native-unistyles";
import { View } from "@src/components";

type MarkdownMessageProps = {
  content: string;
  isUser: boolean;
};

export const MarkdownMessage: React.FC<MarkdownMessageProps> = ({ content, isUser }) => {
  const theme = UnistylesRuntime.getTheme();

  const styles = {
    body: {
      // Ensure good contrast: user bubble has foreground background, so use main text color
      color: theme.colors.text,
      fontSize: 16,
      lineHeight: 22,
    },
    heading1: {
      fontSize: 22,
      fontWeight: "700" as const,
      marginBottom: 8,
    },
    heading2: {
      fontSize: 18,
      fontWeight: "700" as const,
      marginBottom: 6,
    },
    heading3: {
      fontSize: 16,
      fontWeight: "700" as const,
      marginBottom: 4,
    },
    bullet_list: {
      marginVertical: 4,
    },
    ordered_list: {
      marginVertical: 4,
    },
    list_item: {
      flexDirection: "row" as const,
      marginVertical: 2,
    },
    strong: {
      fontWeight: "700" as const,
    },
    em: {
      fontStyle: "italic" as const,
    },
    code_inline: {
      fontFamily: "monospace",
      backgroundColor: theme.colors.surface as string,
      paddingHorizontal: 4,
      paddingVertical: 2,
      borderRadius: 4,
    },
    code_block: {
      fontFamily: "monospace",
      backgroundColor: theme.colors.surface as string,
      padding: 8,
      borderRadius: 6,
      marginVertical: 4,
    },
    link: {
      color: theme.colors.interactive.buttons.default_foreground as string,
      textDecorationLine: "underline" as const,
    },
  } as const;

  return (
    <View
      bg={isUser ? "foreground" : "background"}
      borderWidth={1}
      borderColor="border"
      rounded={14}
      px="3xl"
      py="xs"
      maxWidth="90%"
    >
      <Markdown style={styles}>{content}</Markdown>
    </View>
  );
};
